// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FieldValidationStep-module__formBox--YOP6_ {
    flex-grow: 1;
    padding: 20px;
    /* border-radius: 16px;
    -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14); */
    width: 80%;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
}

.FieldValidationStep-module__btnBoxNext--HSKJo {
    display: flex;
    justify-content: end;
}

.FieldValidationStep-module__titleBox--UxmQI>h4 {
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);

}

.FieldValidationStep-module__titleBox--UxmQI>p {
    font-size: 14px;
    margin: 0;

}

.FieldValidationStep-module__fieldBox--uzY0i {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.FieldValidationStep-module__btnBoxNext--HSKJo {
    display: flex;
    justify-content: space-between;
}



.FieldValidationStep-module__textBox--GTbss>*:nth-child(2) {
    margin-top: 10px;
}

.FieldValidationStep-module__textTitle--SV59P>h4 {
    color: var(--color-title);
    margin: 0;
    font-size: 16px;
}

.FieldValidationStep-module__textItem--k3n5G,
.FieldValidationStep-module__textItem--k3n5G>div {
    display: flex;
    /* gap: 10px; */
    align-items: center;
    justify-content: space-between;
}


.FieldValidationStep-module__textItem--k3n5G>span,
.FieldValidationStep-module__textItem--k3n5G>div>span {
    color: var(--color-title);
    font-weight: 400;
    width: 50%;
    font-size: 15px;
}

.FieldValidationStep-module__textItem--k3n5G>p,
.FieldValidationStep-module__textItem--k3n5G>div>p {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.FieldValidationStep-module__textItem--k3n5G>.FieldValidationStep-module__colorText--jl1TJ {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-primary);
}

.FieldValidationStep-module__textItem--k3n5G>p>span>svg {
    height: 15px;
    width: 15px;
    display: flex;
}

.FieldValidationStep-module__textItemData--KuYUX {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.FieldValidationStep-module__textItemData--KuYUX>span {
    color: #6f879c87;
    font-weight: 400;
    font-size: 13px;
}

.FieldValidationStep-module__textBox--GTbss,
.FieldValidationStep-module__textBoxFirst--Y0F4B {
    border-bottom: 1px solid #e2e2e2;
    margin-top: 20px;
}

@media (max-width: 950px) {
    .FieldValidationStep-module__formBox--YOP6_ {
        width: 80%;
    }

    .FieldValidationStep-module__textItem--k3n5G {
        flex-direction: column;
        align-items: flex-start;
    }


    .FieldValidationStep-module__textItem--k3n5G>span {
        width: 100%;
        font-size: 15px;
    }


}`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-2/ui/FieldValidationStep.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb;;;4DAGwD;IACxD,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,eAAe;IACf,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;;;AAGA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;;IAGA;QACI,WAAW;QACX,eAAe;IACnB;;;AAGJ","sourcesContent":[".formBox {\r\n    flex-grow: 1;\r\n    padding: 20px;\r\n    /* border-radius: 16px;\r\n    -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14); */\r\n    width: 80%;\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.titleBox>h4 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n\r\n}\r\n\r\n.titleBox>p {\r\n    font-size: 14px;\r\n    margin: 0;\r\n\r\n}\r\n\r\n.fieldBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n\r\n\r\n.textBox>*:nth-child(2) {\r\n    margin-top: 10px;\r\n}\r\n\r\n.textTitle>h4 {\r\n    color: var(--color-title);\r\n    margin: 0;\r\n    font-size: 16px;\r\n}\r\n\r\n.textItem,\r\n.textItem>div {\r\n    display: flex;\r\n    /* gap: 10px; */\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n\r\n.textItem>span,\r\n.textItem>div>span {\r\n    color: var(--color-title);\r\n    font-weight: 400;\r\n    width: 50%;\r\n    font-size: 15px;\r\n}\r\n\r\n.textItem>p,\r\n.textItem>div>p {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.textItem>.colorText {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.textItem>p>span>svg {\r\n    height: 15px;\r\n    width: 15px;\r\n    display: flex;\r\n}\r\n\r\n.textItemData {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.textItemData>span {\r\n    color: #6f879c87;\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n}\r\n\r\n.textBox,\r\n.textBoxFirst {\r\n    border-bottom: 1px solid #e2e2e2;\r\n    margin-top: 20px;\r\n}\r\n\r\n@media (max-width: 950px) {\r\n    .formBox {\r\n        width: 80%;\r\n    }\r\n\r\n    .textItem {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n\r\n    .textItem>span {\r\n        width: 100%;\r\n        font-size: 15px;\r\n    }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `FieldValidationStep-module__formBox--YOP6_`,
	"btnBoxNext": `FieldValidationStep-module__btnBoxNext--HSKJo`,
	"titleBox": `FieldValidationStep-module__titleBox--UxmQI`,
	"fieldBox": `FieldValidationStep-module__fieldBox--uzY0i`,
	"textBox": `FieldValidationStep-module__textBox--GTbss`,
	"textTitle": `FieldValidationStep-module__textTitle--SV59P`,
	"textItem": `FieldValidationStep-module__textItem--k3n5G`,
	"colorText": `FieldValidationStep-module__colorText--jl1TJ`,
	"textItemData": `FieldValidationStep-module__textItemData--KuYUX`,
	"textBoxFirst": `FieldValidationStep-module__textBoxFirst--Y0F4B`
};
export default ___CSS_LOADER_EXPORT___;
